export default "__VITE_ASSET__e4703d65__"